/* ui/Navigation.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_slot,
	detach,
	element,
	init,
	insert,
	listen,
	run_all,
	safe_not_equal,
	space,
	toggle_class,
	transition_in,
	transition_out,
	update_slot
} from "svelte/internal";

import { game } from "./store";
import { playerAI, playerOneStore, playerTwoStore } from "../stores/player_store";
import GamePage from "./game/GamePage.svelte";
import EditorPage from "./editor/EditorPage.svelte";
import TournamentPage from "./tournament/TournamentPage.svelte";
import DocumentationPage from "./DocumentationPage.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-bjiwxz-style";
	style.textContent = ".hovered.svelte-bjiwxz{background-color:#eeeeee;color:#0088ee;cursor:pointer}div.svelte-bjiwxz{background-color:rgba(0,0,0,.4);margin-bottom:5px}span.svelte-bjiwxz{transition:color .3s, background-color .3s;color:white;padding-right:15px;padding-left:15px}";
	append(document.head, style);
}

const get_default_slot_changes = dirty => ({ selected: dirty & /*selected*/ 1 });
const get_default_slot_context = ctx => ({ selected: /*selected*/ ctx[0] });

function create_fragment(ctx) {
	let div;
	let span0;
	let t1;
	let span1;
	let t3;
	let span2;
	let t5;
	let span3;
	let t7;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*$$slots*/ ctx[12].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[11], get_default_slot_context);

	return {
		c() {
			div = element("div");
			span0 = element("span");
			span0.textContent = "Game";
			t1 = space();
			span1 = element("span");
			span1.textContent = "Code";
			t3 = space();
			span2 = element("span");
			span2.textContent = "Tournament";
			t5 = space();
			span3 = element("span");
			span3.textContent = "Documentation";
			t7 = space();
			if (default_slot) default_slot.c();
			attr(span0, "class", "svelte-bjiwxz");
			toggle_class(span0, "hovered", /*hovered*/ ctx[1] === "GAME");
			attr(span1, "class", "svelte-bjiwxz");
			toggle_class(span1, "hovered", /*hovered*/ ctx[1] === "CODE");
			attr(span2, "class", "svelte-bjiwxz");
			toggle_class(span2, "hovered", /*hovered*/ ctx[1] === "TOURNAMENT");
			attr(span3, "class", "svelte-bjiwxz");
			toggle_class(span3, "hovered", /*hovered*/ ctx[1] === "DOCUMENTATION");
			attr(div, "class", "svelte-bjiwxz");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, span0);
			append(div, t1);
			append(div, span1);
			append(div, t3);
			append(div, span2);
			append(div, t5);
			append(div, span3);
			insert(target, t7, anchor);

			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;

			if (!mounted) {
				dispose = [
					listen(span0, "click", /*selectGameTab*/ ctx[3]),
					listen(span0, "mouseenter", /*hoverGameTab*/ ctx[6]),
					listen(span0, "mouseleave", /*unhover*/ ctx[10]),
					listen(span1, "click", /*selectCodeTab*/ ctx[2]),
					listen(span1, "mouseenter", /*hoverCodeTab*/ ctx[7]),
					listen(span1, "mouseleave", /*unhover*/ ctx[10]),
					listen(span2, "click", /*selectTournamentTab*/ ctx[4]),
					listen(span2, "mouseenter", /*hoverTournamentTab*/ ctx[8]),
					listen(span2, "mouseleave", /*unhover*/ ctx[10]),
					listen(span3, "click", /*selectDocumentationTab*/ ctx[5]),
					listen(span3, "mouseenter", /*hoverDocumentationTab*/ ctx[9]),
					listen(span3, "mouseleave", /*unhover*/ ctx[10])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*hovered*/ 2) {
				toggle_class(span0, "hovered", /*hovered*/ ctx[1] === "GAME");
			}

			if (dirty & /*hovered*/ 2) {
				toggle_class(span1, "hovered", /*hovered*/ ctx[1] === "CODE");
			}

			if (dirty & /*hovered*/ 2) {
				toggle_class(span2, "hovered", /*hovered*/ ctx[1] === "TOURNAMENT");
			}

			if (dirty & /*hovered*/ 2) {
				toggle_class(span3, "hovered", /*hovered*/ ctx[1] === "DOCUMENTATION");
			}

			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope, selected*/ 2049) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[11], dirty, get_default_slot_changes, get_default_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(t7);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let selected = GamePage;
	let hovered = "";

	function selectCodeTab() {
		game.reset();
		$$invalidate(0, selected = EditorPage);
	}

	function selectGameTab() {
		game.reset();
		$$invalidate(0, selected = GamePage);
	}

	function selectTournamentTab() {
		game.reset();
		$$invalidate(0, selected = TournamentPage);
	}

	function selectDocumentationTab() {
		game.reset();
		$$invalidate(0, selected = DocumentationPage);
	}

	function hoverGameTab() {
		$$invalidate(1, hovered = "GAME");
	}

	function hoverCodeTab() {
		$$invalidate(1, hovered = "CODE");
	}

	function hoverTournamentTab() {
		$$invalidate(1, hovered = "TOURNAMENT");
	}

	function hoverDocumentationTab() {
		$$invalidate(1, hovered = "DOCUMENTATION");
	}

	function unhover() {
		$$invalidate(1, hovered = "");
	}

	let { $$slots = {}, $$scope } = $$props;

	$$self.$set = $$props => {
		if ("$$scope" in $$props) $$invalidate(11, $$scope = $$props.$$scope);
	};

	return [
		selected,
		hovered,
		selectCodeTab,
		selectGameTab,
		selectTournamentTab,
		selectDocumentationTab,
		hoverGameTab,
		hoverCodeTab,
		hoverTournamentTab,
		hoverDocumentationTab,
		unhover,
		$$scope,
		$$slots
	];
}

class Navigation extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-bjiwxz-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Navigation;